<template>
  <div class="company-details-display">
    <div class="row mb-3">
      <div class="col-sm-12">
        <div class="toolbar text-right">
          <dropdown
            :dropUp="false"
            :title="'Company Actions'"
            :icon="'fa fa-briefcase'"
            :actions="actions"
            @action="executeAction($event)">
          </dropdown>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div class="card mb-5">
          <h4 class="card-header">
            <i class="fa fa-fw fa-building"></i> Company Details
          </h4>
          <div class="card-body">
            <responsive-table
              :collapse="false"
              :hideColumns="true">
              <template slot="rows">
                <tr>
                  <td colspan="2">
                    <h4>{{ company.name }}</h4>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Phone</strong>
                  </td>
                  <td>{{ company.phone }}</td>
                </tr>
                <tr>
                  <td colspan="2">
                    <h4><i class="far fa-envelope"></i> Postal Address</h4>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Address</strong>
                  </td>
                  <td>{{ company.address }}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Suburb</strong>
                  </td>
                  <td>{{ company.suburb }}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Postcode</strong>
                  </td>
                  <td>{{ company.postcode }}</td>
                </tr>
                <tr>
                  <td>
                    <strong>State</strong>
                  </td>
                  <td>{{ company.state }}</td>
                </tr>
              </template>
            </responsive-table>
          </div>
        </div>
      </div>
      <div class="col-md-8">
        <nav-tabs>
          <tab name="Managers" icon="fa fa-users">
            <search-form
              ref="companyManagersSearchForm"
              showSearch
              searchHidden
              tableDisplay
              showPaging
              allowNewObject
              :redirectUrl="`/database-manager/companies/${$route.params.companyUuid}#contractors`"
              :options="{
                permalink: 'companyManagers',
                params: {
                  companyUuid: $route.params.companyUuid
                }
              }">
            </search-form>
          </tab>
          <tab name="Contractors" icon="fa fa-briefcase">
            <search-form
            ref="companyContractorsSearchForm"
              showSearch
              searchHidden
              tableDisplay
              showPaging
              allowNewObject
              :redirectUrl="`/database-manager/companies/${$route.params.companyUuid}#contractors`"
              :options="{
                permalink: 'companyContractors',
                params: {
                  CompanyUuid: $route.params.companyUuid
                }
              }">
            </search-form>
          </tab>
        </nav-tabs>
      </div>
    </div>
  </div>
</template>

<script>
  import Dropdown from '@/components/ui/Dropdown'
  import NavTabs from '@/components/ui/NavTab'
  import Api from '@/vuex/api'
  import Tab from '@/components/ui/Tab'
  import SearchForm from '@/components/SearchForm'
  import ResponsiveTable from '@/components/ui/ResponsiveTable'
  import {
    OPEN_MODAL
  } from '@/vuex/types'
  const api = new Api()
  export default {
    name: 'CompanyDetailsDisplay',
    components: {
      Dropdown,
      NavTabs,
      Tab,
      ResponsiveTable,
      SearchForm
    },
    computed: {
      company () {
        return {
          ...this.loadedCompany
        }
      }
    },
    data () {
      return {
        loadedCompany: {},
        actions: [
          { label: 'Edit Company', icon: 'fa fa-edit', command: 'edit' },
          { label: 'Delete Company', icon: 'fa fa-trash', command: 'delete' }
        ]
      }
    },
    async mounted () {
      this.loadedCompany = await api.getCompany(this.$route.params.companyUuid)
    },
    methods: {
      executeAction (action) {
        this[action]({ uuid: this.$route.params.companyUuid })
      },
      edit (payload) {
        let editModal = {
          permalink: 'editCompany',
          options: {
            title: 'Edit Company',
            actionLabel: 'Save'
          },
          params: {
            uuid: payload.uuid,
            redirectUrl: `/database-manager/companies/${this.$route.params.companyUuid}${this.$route.hash}`
          }
        }
        this.$store.dispatch(OPEN_MODAL, editModal)
      },
      delete (payload) {
        let deleteModal = {
          permalink: 'deleteCompany',
          options: {
            title: 'Delete Company',
            actionLabel: 'Delete'
          },
          params: {
            uuid: payload.uuid
          }
        }
        this.$store.dispatch(OPEN_MODAL, deleteModal)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/admin/CompanyDetailsDisplay.vue